export default __webpack_public_path__ + "static/media/draft-icon.a75f26c2.svg";